import AwardsCarousel25 from "./awardsCarousel25";

export default AwardsCarousel25;
